import $ from 'jquery';
import Cookies from 'js-cookie';

export default function({
    selector      = '.browser-alert--cookies-info',
    closeSelector = '.js-close-cookies-info',
    cookieName    = 'cookieInfo'
} = {}) {
    var $element = $(selector),
        cookieCheckName = cookieName + '-check';

    // first check if we are able to set cookies, when not we doesn't even show this warning
    // in this case the "activate cookies" warning is showed instead
    Cookies.set(cookieCheckName, true, {expires: Infinity});

    // if the cookie doen't exists yet show the info
    if (Cookies.get(cookieCheckName) !== undefined && Cookies.get(cookieName) === undefined) {
        $element.show();

        // set the info as soon as the message the first time was displayed
        Cookies.set(cookieName, true, {expires: Infinity});

        // init the close click to fade out the element
        $(closeSelector).click(function(event) {
            event.preventDefault();
            $element.slideUp();
        });

        // after a default set of time close the element automatically
        setTimeout(function() {
            $element.slideUp();
        }, 10000);
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lib/alerts/cookies-info.js